<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectedCode.COD_MDLE"
              :selectedSmd="frame0.selectedCode.COD_SMDLE"
              defaultMdOption="all"
              defaultSmdOption="all"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="use"
              defaultOption="all"
              :selected="frame0.selectedCode.COD_USE"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="searchCond"
              :pageId="this.$options.name"
              codeId="COD_WKFL_SEARCH_COND"
              :selected="frame0.selectedCode.COD_WKFL_SEARCH_COND"
              defaultOption="all"
              :initialSelectedIndex="0"
              style="width:58%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              ref="searchField"
              v-model="frame0.searchWord"
              maxlength="50"
              @keyup.enter="onClickSearch"
            />
          </div>  
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsWorkflow'"
        :multiselect="multiselect"
        :showDisplayCountControl="false"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickApply"
        >
          {{ $t('MSG_BTN_SELT') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00010', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() {
        return null;
      },
    },
    pageInitialData: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      multiselect: false,
      frame0: {
        selectedCode: {
          COD_MDLE: { key: '', label: '' },
          COD_SMDLE: { key: '', label: '' },
          COD_USE: { key: '', label: '' },
          COD_WKFL_SEARCH_COND: { key: '', label: '' },
        },
        workflowId: '',
        workflowName: '',
        searchWord: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_WKFL_ID'),
        datafield: 'workflowId',
      }, {
        text: this.$t('MSG_TXT_WKFL_NM'),
        datafield: 'workflowName',
      }, {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'workflowUseName',
        width: '80px',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsWorkflow',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'workflowId', map: 'workflowId' },
      { type: 'string', name: 'workflowName', map: 'workflowName' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'workflowUseYn', map: 'workflowUseYn' },
      { type: 'string', name: 'workflowExplanationContent', map: 'workflowExplanationContent' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'workflowUseName', map: 'workflowUseName' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'displayLanguageId', map: 'displayLanguageId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
    ],
  }],
  mounted() {
    this.setMultiSelectYn();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 단일/멀티 선택 여부
     * default 단일 선택
     */
    setMultiSelectYn() {
      if (!utils.isUndefined(this.pageInitialData.multiselect)) {
        this.multiselect = this.pageInitialData.multiselect;
      }
    },
    /**
     * 워크플로우 목록 조회
     */
    onClickSearch() {
      const queryParams = {
        moduleCode: this.frame0.selectedCode.COD_MDLE.key,
        subModuleCode: this.frame0.selectedCode.COD_SMDLE.key,
        workflowUseYn: this.frame0.selectedCode.COD_USE.key,
        searchConditionCode: this.frame0.selectedCode.COD_WKFL_SEARCH_COND.key,
        searchWord: this.frame0.searchWord,
      };

      http.request(this.$options.name, 'DTS_CMR_00030', {
        query: queryParams,
      }).then(res => {
        this.dsWorkflow.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 리셋
     */
    onClickReset() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          // this.$refs.smComboFrame0.reset();
          this.$refs.smComboFrame0.selectMd('ALL');
          this.$refs.use.reset();
          this.$refs.searchCond.reset();
        } else {
          this.frame0[key] = '';
        }
      });
    },
    /**
     * Button Event
     */
    onClickCancel() {
      this.closePagePopup('');
    },
    onClickApply() {
      const selectedData = this.dsWorkflow.getSelectedRawData();
      if (selectedData.length > 0) {
        this.closePagePopup(selectedData);
      } else {
        // 선택 안했을 때
        utils.messageBox('information', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
  },
};
</script>
<style scoped>
</style>
